import React from 'react';
import { ListColumnType, ListFilterFieldType, ListMoreMenuConfig } from 'types/ListTypes';
import { BulkActionsConfig } from 'types/BulkActionTypes';
import AbstractList from 'components/lists/AbstractList';
import ProductForm from './ProductForm';
import { useSettings } from 'services/settings/SettingsContext';
import { renderPriceFloatColumn } from 'components/lists/functions/renderListColumn';

// Enable the bulk actions panel for this list, products are deactivated instead of deleted
const productBulkActions: BulkActionsConfig = {
    objectKey: 'product',
    deleteOrDeactivate: 'deactivate',
    showExport: true,
};

// Configure the more menu of this list
const productMoreMenu: ListMoreMenuConfig = {
    importObject: 'product',
    inactiveItemsToggle: {
        semantic: 'deactivated',
        activeParams: { is_active: false },
    },
};

// Set the filter fields of this list
const productFilterFields: ListFilterFieldType[] = [
    {
        type: 'search',
        name: 'search',
        label: 'forms.search_label',
        placeholder: 'forms.search_placeholder',
        queryParam: 'search',
        width: 1.5
    },
    {
        type: 'dropdown',
        name: 'category',
        label: 'lists.filters.category_label',
        queryParam: 'category',
        requiredFeature: 'product_categories',
        apiRequest: {
            endpoint: 'get_productcategory_list',
            params: { is_active: true, is_product: true },
            object: 'category'
        },
        width: 1.25
    }
];

// Rename the name of the function:
const ProductList: React.FC = () => {
    const { userLocale } = useSettings();

    // Specify the options of this list:
    const objectName = 'product.general.object_name'
    const query = {
        endpoint: 'get_product_list',
        defaultParams: { 'is_active': true },
        object: 'product'
    }
    const showColumnSelector = true

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = true

    // Specify form, detail modal or detailpage for this list
    const formModal = <ProductForm />;
    const onRowClick = 'detailPage' // Either plug in 'editModal' or 'detailPage'
    const detailPageUrl = 'products' // E.g. www.example.com/products/12010

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '7fr', field: 'name', label: 'product.general.name_label' },
        { width: '5fr', field: 'number', label: 'product.general.number_label' },
        { width: '8fr', field: 'description_plain', label: 'product.general.description_label' },
        { width: '4fr', field: 'sale_price', label: 'product.general.sale_price_label', render: (_, row) => renderPriceFloatColumn(row.sale_price, row.sale_price_currency, userLocale) },
    ];

    // If the list is paginated, define the additional columns for the column selector:
    const additionalColumns: ListColumnType[] = [
        { width: '8fr', field: 'created', label: 'product.general.created_label' },
        { width: '8fr', field: 'modified', label: 'product.general.modified_label' },
        { width: '5fr', field: 'unit', label: 'product.general.unit_label' },
        { width: '9fr', field: 'category', label: 'product.general.category_label' },
        { width: '5fr', field: 'division', label: 'product.general.division_label' },
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            // additionalColumns={additionalColumns}
            filterFields={productFilterFields}
            showColumnSelector={showColumnSelector}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
            bulkActions={productBulkActions}
            moreMenu={productMoreMenu}
        />
    );
};

export default ProductList;